//export const BASE_URL = 'http://api.tg-bot.net/';
export const BASE_URL = 'https://newapi.uecolog.ru/';
